<template>
  <div>
    <BreadCrumb
      class="bread"
      :breads="['运维管理', '系统用户', '添加用户']"
    ></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">添加用户</span>
        <el-button class="backList" size="small" @click="back()"
          >返回列表</el-button
        >
      </div>
      <div class="form">
        <el-form
          label-position="right"
          label-width="180px"
          :model="ruleForm"
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item label="登陆账号" prop="username">
            <span>
              <el-input
                maxlength="20"
                placeholder="登陆账号"
                v-model="ruleForm.username"
              >
              </el-input>
            </span>
          </el-form-item>

          <el-form-item label="真实姓名" prop="rel_name">
            <span>
              <el-input
                maxlength="10"
                placeholder="姓名"
                v-model="ruleForm.rel_name"
              >
              </el-input>
            </span>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <span>
              <el-input
                placeholder="密码"
                minlength="6"
                maxlength="20"
                type="password"
                v-model="ruleForm.password"
              >
              </el-input>
            </span>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <span>
              <el-input
                placeholder="确认密码"
                type="password"
                maxlength="20"
                v-model="ruleForm.checkPass"
              >
              </el-input>
            </span>
          </el-form-item>
          <el-form-item label="是否禁用" props="status">
            <el-radio v-model="ruleForm.status" label="NORMOL">正常</el-radio>
            <el-radio v-model="ruleForm.status" label="DISABLE">禁用</el-radio>
          </el-form-item>
          <el-form-item label="性别" props="sex">
            <el-radio v-model="ruleForm.sex" label="MAN">男</el-radio>
            <el-radio v-model="ruleForm.sex" label="WOMEN">女</el-radio>
          </el-form-item>
          <p class="moreInfo">更多信息</p>
          <el-form-item label="手机" prop="phone">
            <span>
              <el-input
                maxlength="11"
                placeholder="手机"
                v-model="ruleForm.phone"
              >
              </el-input>
            </span>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-autocomplete
              class="inline-input"
              v-model="ruleForm.email"
              :fetch-suggestions="emailTipsAdd"
              placeholder="输入邮箱，便于接受运营报表等信息"
              :trigger-on-focus="false"
              @select="handelEmailSelect"
              maxlength="30"
              debounce="0"
            ></el-autocomplete>
          </el-form-item>
          <!-- <el-form-item label="角色" prop="role">
            <span>
              <el-select v-model="ruleForm.role" placeholder="请选择">
                <el-option v-for="(role,key) in roleOption" :key="key" :value="key" :label="role"></el-option>
              </el-select>
            </span>
          </el-form-item> -->
          <el-form-item label="角色">
            <el-input
              size="small"
              v-model="ruleForm.roleData.role"
              suffix-icon="el-icon-search"
              readonly
              @focus="setDialogSearchItem('role')"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否数据同步" props="is_sync">
            <el-radio v-model="ruleForm.is_sync" label="1">是</el-radio>
            <el-radio v-model="ruleForm.is_sync" label="2">否</el-radio>
          </el-form-item>
          <el-form-item
            label="分账比例"
            prop="distribution_ratio"
            v-if="
              (ruleForm.role === 'ADMIN' || ruleForm.role === 'VISITOR') &&
              this.$store.getters.authority({
                name: 'financeAudit',
                type: 'view',
              })
            "
          >
            <el-input v-model="ruleForm.distribution_ratio">
              <i slot="suffix">%</i>
            </el-input>
          </el-form-item>
          <el-form-item label="头像" prop="imageUrl" class="uploadImage">
            <upload
              v-model="ruleForm.imageUrl"
              :limit="1"
              maxSize="0.5"
            ></upload>
          </el-form-item>
          <el-form-item style="width: 90%">
            <div style="text-align: center">
              <el-button type="primary" @click="submitForm('ruleForm', '1')"
                >提交并继续添加</el-button
              >
              <el-button type="success" @click="submitForm('ruleForm', '2')"
                >提交</el-button
              >
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <simple-find-dialog
      :show="dialogVisible"
      @close="closeSimpleDialog"
      :dialogData="dialogData"
      :width="'500px'"
    ></simple-find-dialog>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import upload from "@/components/SimpleUpload";
import apis from "@/config/apis";
import SimpleFindDialog from "@/components/SimpleFindDialog";

import { OSSConfig, isEmail, isNumber } from "@/plugins/common";
import { deepClone } from "@/plugins/util";
const client = OSSConfig();
export default {
  data() {
    var validatename = (rule, value, callback) => {
      let reg = /^[a-zA-Z\u4e00-\u9fa5]+$/;
      let regs = /^[0-9]*$/;
      if (!value) {
        callback(new Error("姓名不能为空"));
      } else {
        if (regs.test(value)) {
          callback(new Error("姓名不能为数字"));
        }
        if (!reg.test(value)) {
          callback(new Error("姓名为1-10个中文或英文,不包含特殊字符"));
        } else {
          callback();
        }
      }
    };
    var validateusername = (rule, value, callback) => {
      let reg = /^[\A-z\d]{3,20}$/;
      if (!value) {
        callback(new Error("登陆账号不能为空"));
      } else {
        if (!reg.test(value)) {
          callback(new Error("登陆账号为3-20个英文或数字或下划线"));
        } else {
          callback();
        }
      }
    };
    var validatemobile = (rule, value, callback) => {
      // let reg = /^((13[0-9])|(17[06-8])|(18[0-9])|(15[0-9]))\d{8}$/;
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!value) {
        callback(new Error("手机号不能为空"));
      } else {
        if (value.length < 11) {
          callback(new Error("请输入11位有效电话"));
        } else if (!reg.test(value)) {
          callback(new Error("请输入有效的手机号码"));
        } else {
          callback();
        }
      }
    };
    var validatePass = (rule, value, callback) => {
      let regs = /^[0-9a-zA-Z_]*$/;
      if (value === "") {
        callback(new Error("密码不能为空"));
      }
      if (!regs.test(value)) {
        callback(new Error("请输入数字、字母、下划线，最大20个字符"));
      }
      if (this.ruleForm.checkPass !== "") {
        this.$refs.ruleForm.validateField("checkPass");
      }
      if (value.length < 6) {
        callback(new Error("密码长度不小于6位数"));
      }
      callback();
    };
    var validatePass2 = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("确认密码不能为空"));
      } else if (this.ruleForm.checkPass !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      nowDialog: "", //现在打开的弹窗里的类型
      dialogData: {},
      imageUrl: "",
      radio: "1",
      roleOption: null,
      ruleForm: {
        rel_name: "",
        username: "",
        status: "NORMOL",
        password: "",
        checkPass: "",
        phone: "",
        replenish: "NO",
        sex: "MAN",
        imageUrl: "",
        is_sync:"2",
        roleData: {
          role: "",
          role_id: "",
        },
      },
      imgURL: "",
      restType: "",
      iS_noImg: "",
      old_imageUrl: "",
      emailTips: [
        {
          value: "@qq.com",
        },
        {
          value: "@163.com",
        },
        {
          value: "@139.com",
        },
        {
          value: "@sina.com",
        },
        {
          value: "@sina.cn",
        },
        {
          value: "@gmail.com",
        },
        {
          value: "@yahoo.com",
        },
        {
          value: "@yahoo.cn",
        },
      ],
      rules: {
        status: [
          {
            required: true,
            message: "请选择是否禁用",
            trigger: "change",
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        replenish: [
          {
            required: true,
            message: "请选择是否为补货员",
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            validator: validatemobile,
            trigger: "blur",
          },
        ],
        // rel_name: [{
        //   required: true,
        //   validator: validatename,
        //   trigger: "blur"
        // }],
        username: [
          {
            required: true,
            validator: validateusername,
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            validator: validatemobile,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            // validator: validatePass,
            trigger: "blur",
          },
        ],
        checkPass: [
          {
            required: true,
            // validator: validatePass2,
            trigger: "blur",
          },
        ],
        imageUrl: [
          {
            required: true,
            message: "请上传头像",
            trigger: "change",
          },
        ],
        role: {
          required: true,
          message: "请选择用户角色",
        },
        email: {
          validator: function (rule, value, callback) {
            if (value && !isEmail(value)) {
              callback(new Error("请输入正确的邮箱"));
            }
            callback();
          },
        },
        distribution_ratio: {
          validator: function (rule, value, callback) {
            if (value && (!isNumber(value) || value < 1 || value > 100)) {
              callback(new Error("请输入1-100之间的整数"));
            }
            callback();
          },
        },
      },
    };
  },
  mounted() {
    this.getRole();
  },
  methods: {
    //打开弹出选择配置
    setDialogSearchItem(type) {
      switch (type) {
        case "role":
          this.dialogData = {
            searchItems: [
              {
                key: "name",
                label: "产品型号",
              },
            ],
            searchTableItem: [
              {
                key: "name",
                name: "类型名称",
              },
            ],
            proxyLink: "role_list",
            proxyType: "get",
          };
          break;
      }
      this.dialogVisible = true;
      this.nowDialog = type;
    },
    //关闭简单弹出窗口（选择)
    closeSimpleDialog(data) {
      console.log(data);
      this.dialogVisible = false;
      switch (this.nowDialog) {
        case "role":
          this.ruleForm.roleData = data ? data : {};
          this.ruleForm.roleData.role_id = this.ruleForm.roleData.id;
          this.ruleForm.roleData.role = this.ruleForm.roleData.name;
          break;
      }
    },
    back() {
      this.$router.go(-1);
    },
    submitForm(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.restType = type;
          this.sublimtUp(type);
        }
      });
    },
    getRole() {
      this.$axios.get(apis.getRole).then((res) => {
        this.roleOption = res.data.data;
      });
    },
    emailTipsAdd(queryString, cb) {
      let _list = deepClone(this.emailTips);
      let emailUrl = queryString.substring(
        queryString.indexOf("@"),
        queryString.length
      );
      if (queryString) {
        if (queryString.indexOf("@") > -1) {
          _list = _list.filter((item) => {
            return item.value.indexOf(emailUrl) > -1;
          });
        }
        _list.forEach((item) => {
          item.value = queryString + item.value;
          item.value =
            queryString.indexOf("@") > -1
              ? item.value.replace(emailUrl, "")
              : item.value;
        });
      }
      cb(_list);
    },
    handelEmailSelect(item) {},
    /*提取上传逻辑*/
    sublimtUp(type) {
      let {
        id,
        username,
        rel_name,
        password,
        phone,
        status,
        sex,
        imageUrl,
        email,
        role,
        is_sync,
        distribution_ratio,
      } = this.ruleForm;
      let jsonData = {
        username: username,
        rel_name: rel_name,
        password: Base64.encode(password),
        phoneNumber: Number(phone),
        rel_name: rel_name,
        sex: sex,
        status: status,
        is_sync:is_sync == "2" ? 2 : 1,
        image_url: imageUrl,
        email: email,
        // role: role,
        role: this.ruleForm.roleData.role_id,
        distribution_ratio:
          role === "ADMIN" || role === "VISITOR" ? distribution_ratio : 0,
      };
      let url = `${apis.addUser}`;

      this.$axios.post(url, jsonData).then((data) => {
        let datas = data.data;
        if (datas.code == 200) {
          this.$message({
            type: "success",
            message: datas.msg,
          });
          if (type === "2") {
            this.$router.push({
              path: "/index/UserMangement",
              query: Object.assign({}, this.$route.query),
            });
          } else {
            this.resetForm("ruleForm");
          }
        } else {
          this.$message({
            type: "error",
            message: datas.msg,
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs.upload.clearFiles();
      this.ruleForm.status = "NORMOL";
      this.ruleForm.sex = "MAN";
      this.ruleForm.replenish = "NO";
      this.ruleForm.imageUrl = "";
    },
  },
  components: {
    BreadCrumb,
    upload,
    SimpleFindDialog,
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
<style lang="scss" scoped>
.wrap {
  height: 100%;
}

.bread {
  padding-bottom: 20px;
}

.nameFt {
  font-size: 14px;
  color: #333;
  padding-left: 17px;
}

.backList {
  width: 90px;
  margin-right: 20px;
}

.header {
  width: 100%;
  height: 46px;
  line-height: 46px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(236, 239, 241, 1);

  .addCustom {
    padding: 9px 10px;
    margin-right: 17px;
  }
}

.form {
  width: 90%;
  margin: 30px auto;
  clear: both;

  .el-form-item {
    width: 50%;
    float: left;

    .elInput {
      width: 100%;
    }
  }

  .line {
    width: 100%;
    height: 2px;
    border-bottom: 1px dotted #d8d8d8;
    padding-top: 200px;
    margin-top: 20px;
  }

  .moreInfo {
    margin-left: -5%;
    padding-top: 14%;
    color: #006633;
    font-weight: bolder;
  }

  .uploadImage {
    padding-top: -30px;
    width: 100%;
  }
}

.el-autocomplete {
  width: 100%;
}
</style>
